import { render, staticRenderFns } from "./SignOutBtn.vue?vue&type=template&id=252cf471&"
import script from "./SignOutBtn.vue?vue&type=script&lang=js&"
export * from "./SignOutBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports